import { useCallback, useEffect, useMemo, useState } from "react";

import { useNamespace } from "../integration/withModuleContext";
import { useStorageClient } from "./StorageClientProvider";

const returnNull = () => null;
export const createPersistedState = ({ type, key, isGlobal = false } = {}) => {
  const useStorageKey = () => {
    const namespace = useNamespace();
    const scope = isGlobal ? "" : `${namespace}::`;
    return scope + key;
  };

  const useFallbackGetter = (fallbackValue) => {
    return useMemo(() => {
      return typeof fallbackValue === "function"
        ? fallbackValue
        : () => fallbackValue;
    }, [fallbackValue]);
  };
  return (fallbackValue = returnNull) => {
    const storageKey = useStorageKey();
    const getFallbackValue = useFallbackGetter(fallbackValue);
    const storageClient = useStorageClient();
    const storage = storageClient.get(type);
    const storageValue = storage.get(storageKey, getFallbackValue());
    const [, setValue] = useState(storageValue);
    const setStorageValue = useCallback(
      (value) => {
        const nextValue =
          typeof value === "function"
            ? value(storage.get(storageKey, getFallbackValue()))
            : value;
        setValue(nextValue);
        storage.set(storageKey, nextValue);
      },
      [storage, getFallbackValue, storageKey],
    );
    useEffect(() => {
      const callbackToken = storageClient.listenChangeUserConsent(() => {
        const storageValue = storage.get(storageKey, getFallbackValue());
        setStorageValue(storageValue);
      });
      return () => {
        storageClient.stopListeningChangeUserConsent(callbackToken);
      };
    }, [storageClient, storage, storageKey, getFallbackValue, setStorageValue]);

    return [storageValue, setStorageValue];
  };
};
